<template>
  <el-dialog :title="title" :visible.sync="visible" width="760px" append-to-body>
    <div v-loading="loading" class="circle-detail-dialog">
      <div class="circle-header">
        <el-image v-if="detail.coverLogo" class="cover-logo" :src="detail.coverLogo" fit="cover"></el-image>
        <div v-else class="cover-logo placeholder">
          <i class="el-icon-collection-tag"></i>
        </div>
        <div class="circle-main">
          <div class="name-row">
            <span class="circle-name">{{ detail.name || detail.circleName || '--' }}</span>
            <el-tag size="mini" :type="auditTagType(detail.auditStatus)">{{ auditText(detail.auditStatus) }}</el-tag>
            <el-tag v-if="detail.topState == 1" size="mini" type="warning">置顶</el-tag>
          </div>
          <div class="circle-desc">{{ detail.circleDescribe || '暂无圈子简介' }}</div>
        </div>
      </div>

      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="创建者">{{ detail.nickName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="圈主">{{ detail.mastNickName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="圈子状态">{{ circleStateText(detail.circleState) }}</el-descriptions-item>
        <el-descriptions-item label="浏览权限">{{ browseText(detail.browsePermissions) }}</el-descriptions-item>
        <el-descriptions-item label="发帖等级">{{ detail.releaseGrade || 0 }}</el-descriptions-item>
        <el-descriptions-item label="浏览等级">{{ detail.browseGrade || 0 }}</el-descriptions-item>
        <el-descriptions-item label="发帖次数限制">{{ detail.limitPostingNumber || 0 }}</el-descriptions-item>
        <el-descriptions-item label="排序">{{ detail.sort || '--' }}</el-descriptions-item>
        <el-descriptions-item label="关注数">{{ detail.followNumber || detail.virtualFollow || 0 }}</el-descriptions-item>
        <el-descriptions-item label="帖子数">{{ detail.postingNumber || detail.virtualPostingNumber || 0 }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detail.createTime || '--' }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detail.updateTime || '--' }}</el-descriptions-item>
        <el-descriptions-item label="管理规范" :span="2">{{ detail.circleAdminDesc || '--' }}</el-descriptions-item>
        <el-descriptions-item v-if="detail.result" label="审核结果" :span="2">{{ detail.result }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </el-dialog>
</template>

<script>
import { circleDetailApi } from '@/api/user'

export default {
  name: 'CircleDetailDialog',
  data() {
    return {
      visible: false,
      loading: false,
      title: '圈子详情',
      detail: {}
    }
  },
  methods: {
    open(circleId, fallback = {}) {
      this.visible = true
      this.loading = true
      this.detail = { ...fallback }
      if (!circleId) {
        this.loading = false
        return
      }
      circleDetailApi(circleId).then(res => {
        if (res.code == 200 && res.data) {
          this.detail = res.data
        } else {
          this.$message.error(res.msg || '获取圈子详情失败')
        }
      }).catch(err => {
        this.$message.error(err || '获取圈子详情失败')
      }).finally(() => {
        this.loading = false
      })
    },
    auditText(status) {
      const map = {
        0: '待审核',
        1: '已通过',
        2: '已拒绝',
        3: '被举报下架'
      }
      return map[status] || '待审核'
    },
    auditTagType(status) {
      if (status == 1) return 'success'
      if (status == 2 || status == 3) return 'danger'
      return 'warning'
    },
    circleStateText(status) {
      return status == 1 ? '隐藏' : '可见'
    },
    browseText(value) {
      const map = {
        0: '全部用户可见',
        1: '会员可见',
        2: '审核可进入'
      }
      return map[value] || '--'
    }
  }
}
</script>

<style scoped lang="scss">
.circle-detail-dialog {
  min-height: 200px;
}

.circle-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
  padding: 16px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.cover-logo {
  flex-shrink: 0;
  width: 84px;
  height: 84px;
  border-radius: 8px;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e9eef3;
  color: #909399;
  font-size: 30px;
}

.circle-main {
  min-width: 0;
}

.name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.circle-name {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.circle-desc {
  color: #606266;
  line-height: 1.6;
  word-break: break-word;
}
</style>
